import { render, staticRenderFns } from "./SingleAgent.vue?vue&type=template&id=740fd2e1&scoped=true&"
import script from "./SingleAgent.vue?vue&type=script&lang=js&"
export * from "./SingleAgent.vue?vue&type=script&lang=js&"
import style0 from "./SingleAgent.vue?vue&type=style&index=0&id=740fd2e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740fd2e1",
  null
  
)

export default component.exports